// Miniature wireframe of the prospect page, drawn from the same blocks the public view renders.
import { FIXED_BLOCKS } from "./proposalLayout";

const fixedLabel = Object.fromEntries(FIXED_BLOCKS.map((b) => [b.id, b.label]));

function MiniSection({ reversed, count }) {
  return (
    <div className={`ppv-sec ${reversed ? "is-rev" : ""}`}>
      <div className="ppv-copy">
        <i className="ppv-eyebrow" /><i className="ppv-h" /><i className="ppv-line" /><i className="ppv-line short" />
        <div className="ppv-pills">{Array.from({ length: Math.min(count, 3) }).map((_, i) => <i key={i} />)}</div>
      </div>
      <div className="ppv-media" />
    </div>
  );
}

function MiniPackages({ count }) {
  const n = Math.max(1, Math.min(count, 4));
  return (
    <div className="ppv-pack">
      <i className="ppv-h center" />
      <div className="ppv-cards">{Array.from({ length: n }).map((_, i) => <div key={i} className={`ppv-card ${i === 1 ? "is-hi" : ""}`}><i /><b /><i /><i /></div>)}</div>
    </div>
  );
}

function MiniFixed({ id, rows }) {
  if (id === "pricing") return (
    <div className="ppv-table"><i className="ppv-h center" />{Array.from({ length: Math.min(Math.max(rows, 2), 5) }).map((_, i) => <div key={i} className="ppv-tr"><i /><b /><b /></div>)}</div>
  );
  if (id === "impact") return (
    <div className="ppv-impact"><i className="ppv-h center" /><div className="ppv-tabs"><i className="on" /><i /></div><div className="ppv-slider"><b /></div><div className="ppv-bars"><i style={{ height: "60%" }} /><i style={{ height: "100%" }} className="on" /></div></div>
  );
  if (id === "notes") return (
    <div className="ppv-notes"><i className="ppv-h" /><i className="ppv-line" /><i className="ppv-line" /><i className="ppv-line short" /></div>
  );
  return (
    <div className="ppv-gs"><i className="ppv-h center" /><div className="ppv-gs-cards"><div /><div className="is-hi" /><div /></div></div>
  );
}

export default function ProposalPagePreview({ agencyName, blocks, hidden, activeKey, onHover, onPick }) {
  let sectionIdx = 0;
  return (
    <div className="ppv" data-testid="rdd-page-preview">
      <div className="ppv-page">
        <div className="ppv-hero" data-testid="ppv-hero">
          <i className="ppv-eyebrow light" />
          <span className="ppv-title">{agencyName?.trim() || "Agency name"}</span>
        </div>
        {blocks.map((block) => {
          const isHidden = block.type === "fixed" && hidden[block.id];
          const label = block.type === "section" ? block.category : block.type === "packages" ? "Packages" : fixedLabel[block.id];
          const cls = `ppv-block ${activeKey === block.key ? "is-active" : ""} ${isHidden ? "is-hidden" : ""}`;
          const rev = block.type === "section" ? sectionIdx++ % 2 === 1 : false;
          return (
            <div
              key={block.key}
              className={cls}
              title={isHidden ? `${label} (hidden on the page)` : label}
              onMouseEnter={() => onHover?.(block.key)}
              onMouseLeave={() => onHover?.(null)}
              onClick={() => onPick?.(block.key)}
              data-testid={`ppv-block-${block.key}`}
            >
              <span className="ppv-tag">{label}</span>
              {block.type === "section" && <MiniSection reversed={rev} count={block.products.length} />}
              {block.type === "packages" && <MiniPackages count={block.bundles.length} />}
              {block.type === "fixed" && <MiniFixed id={block.id} rows={hidden.pricingRows || 3} />}
            </div>
          );
        })}
        <div className="ppv-footer"><i /></div>
      </div>
    </div>
  );
}
